import { FETCH_APPLIANCE_LIST_ACTIONS } from '../../dataFetchers/appliancesDataFetcher';

const appliancesReducer = (state = {
    appliancesList: {}
}, action) => {
    switch(action.type) {
        case FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_SUCCESS: 
            let appliancesList = action.payload;
            //Remove Total from appliances list
            state = {
                ...state,
                appliancesList: appliancesList
            }
            break;
        case FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_FAILED: 
            state = {
                ...state,
                appliancesList: {
                    "2":"Pump",
                    "67":"Pump",
                    "3":"Heating",
                    "4":"Cooling",
                    "5":"Cooking",
                    "6":"Clothes Dryer",
                    "71":"Lighting",
                    "7":"Water Heating",
                    "8":"Always On",
                    "9":"Refrigeration",
                    "74":"Office Equipment",
                    "75":"Ventilation",
                    "11":"Hot Water Dispenser",
                    "12":"Central Furnace",
                    "16":"Solar",
                    "17":"Total",
                    "18":"Electric Vehicle",
                    "19":"Room Heater",
                    "20":"Central Heater",
                    "21":"Hot Tub",
                    "22":"Cooking Range",
                    "23":"Cooking Oven",
                    "24":"Cooking Toaster",
                    "25":"Cooking Microwave",
                    "26":"Cooking Hot Water Dispenser",
                    "27":"Well Pump",
                    "28":"Computer",
                    "29":"Television",
                    "30":"Washing Machine",
                    "31":"DishWasher",
                    "34":"Cooling",
                    "99":"Other",
                    "35":"Heating",
                    "43":"Fast Pulsing High Energy",
                    "44":"Shower",
                    "59":"Laundry",
                    "66":"Entertainment"
                }
            }
            break;
        default: 
            break;
    }
    return state;
}

export default appliancesReducer;